<template>
  <div class="flex flex-col items-center gap-[12px] w-full">
    <div class="pb-[12px] w-full">
      <h2 class="text-[28px] font-bold text-[#3a3d44] text-center leading-[1.3]">Зайдите в вашу почту</h2>
    </div>
    <p class="text-sm text-[rgba(58,61,68,0.6)] text-center">
      Мы отправили ссылку для подтверждения сброса пароля
    </p>
    <p class="text-sm text-primary text-center pb-[12px]">{{ email }}</p>
    <p v-if="errorMessage" class="text-[#f8465b] text-sm text-center">{{ errorMessage }}</p>
    <button
      class="bg-primary rounded-[12px] py-3 w-[368px] max-md:w-full text-white font-bold text-base disabled:opacity-50"
      :disabled="loading"
      @click="resend"
    >
      <span v-if="loading" class="loader-inline mr-2" />
      Отправить письмо еще раз
    </button>
    <div class="flex items-center justify-center pt-[12px]">
      <span class="text-primary text-sm cursor-pointer" @click="$emit('setMode', LoginMode.EMAIL_PASSWORD)">
        Назад
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LoginMode } from '~/interfaces/login/UI';
import AuthService from '~/services/AuthService';

const emit = defineEmits<{
  (e: 'setMode', mode: LoginMode): void;
}>();

const props = defineProps<{
  email: string;
}>();

const loading = ref(false);
const errorMessage = ref('');

const resend = async () => {
  loading.value = true;
  errorMessage.value = '';
  try {
    await AuthService.passwordRequest(props.email);
  } catch {
    errorMessage.value = 'Повторная отправка письма возможна через 1 минуту';
  } finally {
    loading.value = false;
  }
};
</script>
